<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="dis_flex">
        <a-icon type="left-circle" class="btn_back" theme="twoTone" @click="$router.go(-1)" />
        <h2 class="title_from">{{ formTitle }}</h2>
        <!-- <a-button class="" type="link" @click="$router.go(-1)">
          <a-icon type="left-circle" />
        </a-button> -->
      </div>

    </a-card>
  </page-header-wrapper>
</template>

<script>

import { businessDistrictList } from '@/api/setting/businessdistrict'
import { streetList, getStreet, addStreet, updateStreet, delStreet } from '@/api/setting/street'

export default {
  name: 'StreetDetail',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '编辑街道信息',
      opt: 'add', // 操作 add 新增 ，edit 修改

     queryBusinessDisParam: {
        businessDistrictName: undefined, // 商圈名称
        districId: undefined // 区域ID
      },
      businessDisList: [],
      loading: false,

      houseNumberTypeOpts: [], // 门牌号类型
      districtOpts: [], // 区域

      // 表单参数
      dataInfo: {
        businessDistrictId: undefined, //	商圈ID
        houseNumberEnd: undefined, //	门牌号止
        houseNumberStart: undefined, //	门牌号起
        houseNumberType: undefined, //	门牌号类型 字典表类型：house_number_type
        id: undefined, //	id，新增时不传，修改时必传
        streetFullName: undefined, //	街道全称
        streetShortName: undefined //	街道简称
      },
      keyId: undefined,
      rules: {
        businessDistrictId: [{ required: true, message: '必填', trigger: 'blur' }],
        houseNumberStart: [{ required: true, message: '校验不合格', trigger: 'blur', validator: this.houseNumValidator }],
        houseNumberEnd: [{ required: true, message: '校验不合格', trigger: 'blur', validator: this.houseNumValidator }],
        houseNumberType: [{ required: true, message: '必选', trigger: 'blur' }],
        streetFullName: [{ required: true, message: '必填', trigger: 'blur' }],
        streetShortName: [{ required: true, message: '必填', trigger: 'blur' }]
      }
      // editRules:{
      //    id: [{ required: true, message: '必选', trigger: 'blur' }], //新增时不传，修改时必传
      //    streetFullName: [{ required: true, message: '必填', trigger: 'blur' }],
      //   streetShortName: [{ required: true, message: '必填', trigger: 'blur' }],
      // }
    }
  },
  filters: {

  },
  created () {
     // 是否
    this.getDicts('house_number_type').then(response => {
       this.houseNumberTypeOpts = response.data
    })

    this.reset()
    this.getBusinessDistrict()

    let streetId = this.$route.query.dataId
    if (streetId != '' && streetId != null && typeof (streetId) !== 'undefined') {
      streetId = parseInt(this.$route.query.dataId)
      // this.dataInfo.keyId=businessDisId;
      getStreet(streetId).then(response => {
        this.dataInfo = response.data
      })
      this.opt = 'edit'
    } else {
      this.opt = 'add'
    }

    // let businessDisId=this.$route.query.dataId;
    // if(businessDisId!=""&&businessDisId!=null&& typeof(businessDisId)!='undefined'){
    //   businessDisId=parseInt(this.$route.query.dataId);
    //   this.dataInfo.keyId=businessDisId;
    //   getStreet(businessDisId).then(response => {
    //     this.dataInfo = response.data
    //   })
    // }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    // 获取商圈列表
    getBusinessDistrict () {
      this.loading = true
      businessDistrictList(this.queryParam).then(response => {
          if (response.code == 200) {
            const resData = response.data
            this.businessDisList = resData
          }
          this.loading = false
        }
      )
    },

    reset () {
       this.dataInfo = {
            businessDistrictId: undefined, //	商圈ID
            houseNumberEnd: undefined, //	门牌号止
            houseNumberStart: undefined, //	门牌号起
            houseNumberType: undefined, //	门牌号类型 字典表类型：house_number_type
            id: undefined, //	id，新增时不传，修改时必传
            streetFullName: undefined, //	街道全称
            streetShortName: undefined //	街道简称
        }
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.dataInfo.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.dataInfo.id !== undefined) {
            updateStreet(this.dataInfo).then(response => {
              this.$message.success('修改成功', 3)
              this.goList()
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addStreet(this.dataInfo).then(response => {
              this.$message.success('新增成功', 3)
              this.goList()
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    pointChange (value) {
      console.log('changed', value)
    },

    goList () {
      this.$router.push({ path: '/setting/houses/housesdict' })
    },
    houseNumValidator (rule, value, callback) {
        const data = this.dataInfo
        const bigN = data.houseNumberEnd
        const smallN = data.houseNumberStart
        if (bigN < smallN) {
            callback('街道起始号不能超过街道终止号')
        } else {
            callback()
        }
    }
  }
}
</script>
<style scoped>
.ml20{
  margin-left:20px;
}
.dis_flex{
    display:flex;
}
.title_from{
  font-weight: bold;
}
.row_data{
    display:flex;
    flex-wrap:wrap;
}

.item_businessDis{
    width:280px;
    margin-right:20px;
}
.btn_opt{
    margin-right:50px;
}
</style>
